import { useState, useEffect, useCallback, useRef, Fragment, useMemo } from 'react'
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {
  Divider,
  Grid,
  Button,
  TextField,
  FormControl,
  FormLabel,
  InputAdornment,
  RadioGroup,
  FormControlLabel,
  Radio,
  Select,
  MenuItem,
  List,
  ListItem,
  Paper,
  InputBase,
  IconButton,
  Modal,
  Typography,
  Box,
  CardContent,
  Card,
  CardMedia,
  colors,
  CircularProgress
} from '@mui/material';
import Payblockone from "../../assets/paymentblock/EFT.png"
import Payblocktwo from "../../assets/paymentblock/image__11_-removebg-preview__1_-removebg-preview.png"
import Payblockthree from "../../assets/paymentblock/COD.png"
import Payblockfour from "../../assets/icons/sticittpaylogo.png"
import Zapper from "../../assets/icons/Zapper_Logo_Electric_Blue_RGB.png"
import Ikhokha from "../../assets/icons/logo_ikhokha.svg"
// import Ikhokha from "../../assets/icons/ikhokha.png"
import Payblockfive from "../../assets/paymentblock/cash-payment.png"

import Patstore from "../../assets/paymentblock/payatstore.png"
import Payatreception from "../../assets/paymentblock/payatreception.png"
import VISA from "../../assets/paymentblock/VISACARD.png"
import MASTER from "../../assets/paymentblock/Mastercard.png"
import EFT from "../../assets/paymentblock/IIEFT.png"
import COD from "../../assets/paymentblock/CODD.png"

import CheckBoxIcon from '@mui/icons-material/CheckBox';
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import _ from 'lodash';
import { enqueueSnackbar, useSnackbar } from 'notistack';
import { useNavigate, useLocation } from 'react-router-dom';
import { useForm, Controller } from "react-hook-form";
import AddIcon from '@mui/icons-material/Add';
import { GoogleMap, Autocomplete, Marker, useLoadScript } from '@react-google-maps/api';
import {
  setKey,
  fromAddress,
  geocode,
  RequestType
} from "react-geocode";

import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import SearchIcon from '@mui/icons-material/Search';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';

import CustomLayout from 'views/CustomLayout'
import CustomBreadcrumbs from "components/Breadcrumbs";
import Loader from 'components/Loader';
import axiosInstance from "configs/axiosConfig";
import { APIRouteConstants } from 'constants/routeConstants';
import { countryCode } from 'constants/appData/filters';
import { GLOBAL_COUNTRY_CODE, GLOBAL_CURRENCY, GOOGLE_KEY } from 'constants/appConstants';
import SticittPayment from 'components/Payment/SticittPayment';
import instance from 'configs/axiosConfig';
import { useAuth } from 'oidc-react';
import ShippingOptionCard from './ShippingOption';
import { useSelector } from 'react-redux';
import { customeStyle } from 'utils/style';
import { clearCart, getCartItemsFromLocalStorage } from 'utils/cart';
import { updateCartCount } from 'utils/website';
import { updateUserDetail } from 'utils/auth';
import Loaderwithtext from 'components/Loader/Loaderwithtext';
import { formatCurrencyNew } from 'utils/helper';
import MuiResponsivePhoneInputControlled from "../../containers/AuthDialog/MuiResponsivePhoneInputControlled";


let formatCurrency = new Intl.NumberFormat(undefined, {
  style: 'currency',
  currency: GLOBAL_CURRENCY.code,
  currencyDisplay: 'narrowSymbol',
  minimumFractionDigits: 2
});

const showName = (args) => {
  return _.compact(args).join(' ')
}

// const showAddress = (address) => {
//     return (
//         <div className="address-wrapper">
//             <span>{showName([address.first_name, address.last_name])} | {showName([address.country_code, address.phone_number])}</span><br />
//             <Divider/>
//             <span>{address.street_address}</span><br />
//             <span>{address.city}</span><br />
//             <span>{address.state}, {address.country} - {address.pin}</span>
//         </div>
//     )
// }


const showAddress = (address) => {
  return (
    <Grid container spacing={1} sx={{ px: 2, bgcolor: "background.paper", borderRadius: 2 }} pt={0}>
      <Grid xs={12} pt={0}>
        <Typography sx={{ fontSize: customeStyle.typography.subhading, color: "#000" }} textTransform={"capitalize"}>
          {showName([address.first_name, address.last_name])} | {" "}
          {showName([address.phone_number])}
        </Typography>
      </Grid>
      <Grid py={0.5} xs={12}>
        <Divider />
      </Grid>
      <Grid xs={12} pt={0}>
        <Typography sx={{ fontSize: customeStyle.typography.subhading1, color: "#7c7b7b" }}>
          {address.street_address}

        </Typography>
      </Grid>

      <Grid xs={12} pt={0}>
        <Typography sx={{ fontSize: customeStyle.typography.subhading1, color: "#7c7b7b" }}>
          {address.state},  - {address.city} - {address.country} - {address.pin}
        </Typography>
      </Grid>
    </Grid>
  );
};

const libraries = ['places'];
const mapContainerStyle = {
  width: '100%',
  height: '10rem',
};

const GoogleMapContainer = ({
  setValue,
  setLoader,
  location,
  selectLocation
}) => {
  const [zoom, setZoom] = useState(12);
  // const [location, selectLocation] = useState();
  const [autocomplete, setAutocomplete] = useState(null);
  const [mapInstance, setMapInstance] = useState(null);
  const { enqueueSnackbar } = useSnackbar();

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: GOOGLE_KEY,
    libraries,
  });

  const onMapLoad = useCallback((map) => {
    setMapInstance(map);
  }, []);

  useEffect(() => {
    if (mapInstance && location) {
      mapInstance.panTo({ lat: location.lat, lng: location.lng });
      if (location) setZoom(16);
    }
  }, [mapInstance, location]);

  const onMapClick = (e) => {
    setLoader(true)
    selectLocation({
      lat: e.latLng.lat(),
      lng: e.latLng.lng()
    });
    fetchLocation(e.latLng.lat(), e.latLng.lng())
  };

  const setCurrentLocation = () => {
    navigator.geolocation.getCurrentPosition(function (position) {
      selectLocation({
        lat: position.coords.latitude,
        lng: position.coords.longitude
      })
      fetchLocation(position.coords.latitude, position.coords.longitude)
    });
  }

  useEffect(() => {
    setCurrentLocation()
  }, [])

  const handlePlaceSelect = () => {
    setLoader(true);
    const addressObject = autocomplete.getPlace();
    const address = addressObject.formatted_address;
    const lat = addressObject.geometry.location.lat();
    const lng = addressObject.geometry.location.lng();

    selectLocation({ lat, lng });
    setKey(GOOGLE_KEY);
    geocode(RequestType.ADDRESS, address)
      .then(({ results }) => {
        // Handle response
        const { lat, lng } = results[0].geometry.location;
        const { address, state, country, pincode, city, suburb } = retrieveLocation(results);
        setValue('address_line1', address);
        setValue('suburb', suburb);
        setValue('city', city);
        setValue('state', state);
        setValue('country', country);
        setValue('pin', pincode);

        selectLocation({
          lat: lat,
          lng: lng
        })
      })
      .catch(error => {
        enqueueSnackbar('Location not found', { variant: 'error' });
      });

    setLoader(false);
  };

  const fetchLocation = async (lat, lon) => {
    setLoader(true)
    setKey(GOOGLE_KEY);
    geocode(RequestType.LATLNG, [lat, lon].toString(), {
      location_type: "ROOFTOP",
      enable_address_descriptor: true,
    }).then(({ results }) => {
      const { address, state, country, pincode, city, suburb } = retrieveLocation(results);
      setValue('address_line1', address);
      setValue('suburb', suburb);
      setValue('city', city);
      setValue('state', state);
      setValue('country', country);
      setValue('pin', pincode);
    }).catch((area) => {
      enqueueSnackbar('Something went wrong! Please try again', { variant: 'error' });
    })
    setLoader(false)
  }

  const retrieveLocation = (location) => {
    const locationObj = location[location.length - 1].address_components.reduce(
      (acc, component) => {
        if (component.types.includes['street_number']
          || component.types.includes("premise")
          || component.types.includes("neighborhood")
          || component.types.includes("sublocality_level_3")
          || component.types.includes("route")) {
          if (acc.address)
            acc.address = acc.address + ', ' + component.long_name;
          else
            acc.address = component.long_name
        } else if (component.types.includes("administrative_area_level_3")) {
          acc.city = component.long_name;
        }
        else if (component.types.includes("locality")) {
          acc.suburb = component.long_name;
        } else if (component.types.includes("sublocality_level_1")) {
          if (!acc.suburb)
            acc.suburb = component.long_name;
        } else if (component.types.includes("sublocality_level_2")) {
          if (!acc.suburb)
            acc.suburb = component.long_name;
        } else if (component.types.includes("administrative_area_level_1"))
          acc.state = component.long_name;
        else if (component.types.includes("country"))
          acc.country = component.long_name;
        else if (component.types.includes("postal_code"))
          acc.pincode = component.long_name;
        return acc;
      },
      {}
    );
    return locationObj
  }

  if (!isLoaded) {
    return <div>Loading maps</div>;
  }

  if (loadError) {
    return <div>Error loading maps</div>;
  }

  return (
    <>
      {/* <Loader open={!isLoaded} /> */}
      <Grid item lg={4} md={6} sm={12} xs={12} pt={0.5}>
        {/* <div className='form-wrapper' style={{paddingTop:"0px"}}> */}
        <FormControl className='form-control' >
          <Autocomplete onLoad={setAutocomplete} onPlaceChanged={handlePlaceSelect}>
            <Paper
              component="form"
              sx={{
                p: '1px 2px',
                display: 'flex',
                alignItems: 'center',
                width: 220,  // Reduced width 
                height: 36,  // Reduced height
                borderRadius: 2, // Slightly rounded corners
              }}
            >
              <InputBase
                sx={{ ml: 1, flex: 1, fontSize: 14 }} // Smaller font size
                placeholder="Search Area"
                inputProps={{ 'aria-label': 'search google maps' }}
              />
              <Divider sx={{ height: 20, mx: 0.5 }} orientation="vertical" />
              <IconButton type="button" sx={{ p: '2px' }} aria-label="search">
                <SearchIcon fontSize="small" /> {/* Smaller icon */}
              </IconButton>
            </Paper>
          </Autocomplete>

        </FormControl>
        {/* </div> */}
      </Grid>
      <Grid item xs={12} pt={0.5}>
        {/* <div className='form-wrapper' style={{ marginBottom: '1rem' }}> */}
        <FormLabel className='form-label'>
          <Typography sx={{ fontSize: customeStyle.typography.subhading1 }} className='label-text'>
            or Select your delivery location *
            {/* <Typography className='required'></Typography> */}
          </Typography><br />
        </FormLabel>
        {/* </div> */}
        {isLoaded ?
          <GoogleMap
            mapContainerStyle={mapContainerStyle}
            zoom={zoom}
            center={location}
            onClick={onMapClick}
            onLoad={onMapLoad}
          >
            <Marker
              icon={{
                url: 'https://maps.google.com/mapfiles/ms/icons/blue-dot.png', // Adjust the URL as needed
                scaledSize: new window.google.maps.Size(30, 30),
              }}
              position={location} />
            <IconButton
              type="button"
              onClick={setCurrentLocation}
              style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                zIndex: '1',
                cursor: 'pointer',
                backgroundColor: 'white',
                padding: '5px',
                border: '1px solid #ccc',
                borderRadius: '5px',
              }}
              aria-label="search">
              <GpsFixedIcon />
            </IconButton>
          </GoogleMap>
          : ''}
      </Grid>
    </>
  )
}

const Checkout = ({ breadcrumbs }) => {
  const [loader, setLoader] = useState(true);
  const [cartItems, setCartItems] = useState([]);
  const auth = useAuth();
  const webDetails = useSelector(state => state.webDetails);
  const { websiteInfo } = webDetails;
  const navigate = useNavigate();
  const location = useLocation();
  const { orderId } = location.state;
  const { enqueueSnackbar } = useSnackbar();
  const [addressList, setAddressList] = useState([]);
  const [viewAddAddress, setViewAddAddress] = useState(false);
  const [paymentLoader, setPaymentLoader] = useState(false);
  const [selectedAddress, selectAddress] = useState();
  const [cartSummary, setCartSummary] = useState();
  const [paymentModes, setPaymentModes] = useState([]);
  const [paymentid, setPaymentid] = useState();
  const [paymentidRelaykey, setPaymentRelaykey] = useState();
  const [paymentstatus, setPaymentstatus] = useState(null);
  const [selectedPaymentMode, selectPaymentMode] = useState();
  const [locationPin, selectLocation] = useState();
  const { register, formState: { errors }, handleSubmit, control, getValues, setValue, reset } = useForm();
  const [selected, setSelected] = useState("");
  const [userData, setUserData] = useState({})
  const getUserDetails = async (category) => {
    setLoader(true)
    let res = await axiosInstance.get(APIRouteConstants.AUTH.ME);
    let { data } = res;

    if (data && !_.isEmpty(data?.data)) {
      setUserData(data?.data)
      localStorage.setItem("u_user_data", JSON.stringify(data?.data))
      updateUserDetail(data.data)
    }
    setLoader(false)
  }

  const handleSelect = (option) => {
    setSelected(option);
  };
  const getCartItems = async () => {
    setLoader(true)

    let res = await axiosInstance.get(APIRouteConstants.DASHBOARD.GET_CART_ITEMS);
    let { data, response } = res;

    if (data && data.cart_items) {
      setLoader(false)

      setCartItems(data.cart_items);
      if (selected) getCartSummary()
    }
  }
  const getPaymentModes = async () => {
    setLoader(true)
    if (!selected) {
      return;
    }
    let queryParam = {
      delivery_option: selected
    }
    let res = await axiosInstance.get(APIRouteConstants.DASHBOARD.GET_ALL_PAYMENTS, {
      params: queryParam
    });
    let { data, response } = res;

    if (data) {
      setPaymentModes(data)
      setLoader(false)
    }
  }

  const { user } = useSelector(state => state.userDetails);
  const prevUserRef = useRef(user);


  const syncCartFromLocalStorage = async () => {
    setLoader(true)
    let cartItems = getCartItemsFromLocalStorage();
    cartItems = _.map(cartItems, product => ({
      product: product.id,
      quantity: product.quantity
    }))
    let res = await axiosInstance.post(APIRouteConstants.DASHBOARD.UPDATE_CART_ITEMS_LOCAL_STORAGE, cartItems);
    let { data, response } = res;

    if (!_.isEmpty(data)) {
      clearCart()
      getCartItems()
      updateCartCount(true);
    }
  }


  const getCartSummary = async (addressId) => {

    setLoader(true)
    let queryParam = {
      transaction_id: orderId
    }
    if (addressId) queryParam['address_id'] = addressId
    if (selected) queryParam['delivery_option'] = selected


    let res = await axiosInstance.get(APIRouteConstants.DASHBOARD.CART_SUMMARY, {
      params: queryParam
    })
    let { data, response } = res;

    if (response && response.status == 400) {
      if (response?.data?.error)
        enqueueSnackbar(response?.data?.error, { variant: 'error' });
      selectAddress()
      setLoader(false)
    }

    if (!_.isEmpty(data)) {
      setLoader(false)
      setCartSummary(data)
    }
  }

  const getAddressList = async () => {
    let res = await axiosInstance.get(APIRouteConstants.DASHBOARD.GET_ADDRESS_LIST);
    let { data, response } = res;

    if (response
      && response.status === 400
      && response.data) {
      for (let i in response.data) {
        enqueueSnackbar(_.capitalize(i) + ': ' + response.data[i][0], { variant: 'error' });
        setLoader(false)
      }
    }

    if (data) {
      setAddressList(data);
    }
  }
  const [message, setMessage] = useState(null)



  console.log("payment", paymentLoader)
  const proceedOrder = async () => {

    try {
      setMessage(null);

      if (cartSummary && cartSummary?.sub_total === 0) {
        setMessage("Payable amount cannot be zero.");
        return;
      }

      if (selectedPaymentMode === undefined) {
        enqueueSnackbar('Please select a payment method first.', { variant: 'error' });
        return;
      }

      if (selectedPaymentMode?.payment_method_name === "Peach Payments") {
        setPaymentLoader(true)
      } else {

        setLoader(true);
      }
console.log("auth", auth)
      let formData = {
        transactionId: orderId,
        selectedPaymentMode: selectedPaymentMode?.id,
        order_notes: '',
        d6_access_token: auth?.userData?.access_token || localStorage.getItem("D6-access-token"),
        delivery_option: selected
      };

      if (selectedAddress?.id) {
        formData["addressId"] = selectedAddress?.id;
      }

      let res = await axiosInstance.post(APIRouteConstants.DASHBOARD.PROCEED_PAYMENT, formData);
      let { data, response } = res;

      if (response && response.status === 400) {
        if (
          (response?.data && response?.data?.error === "Failed to initiate Peach Payments checkout.")
        ) {
          setMessage("Failed to initiate  Payments.");
          enqueueSnackbar('Failed to initiate  Payments.', { variant: 'error' });
          // setMessage("Payable amount cannot be zero.");
          // enqueueSnackbar('Payable amount cannot be zero.', { variant: 'error' });
          setLoader(false);
          setPaymentLoader(false)
        }
        if (
          (response?.data && response?.data?.error === "Failed to create Sticitt payment ID.")
        ) {
          setMessage("Failed to initiate  Payments.");
          enqueueSnackbar('Failed to initiate  Payments.', { variant: 'error' });
          // setMessage("Payable amount cannot be zero.");
          // enqueueSnackbar('Payable amount cannot be zero.', { variant: 'error' });
          setLoader(false);
          setPaymentLoader(false)
        }
        setLoader(false);
        return;
      }

      if (!_.isEmpty(data)) {
        if (data.checkout_url) {
          // newTab.location.href = data.checkout_url; 
          // newTab.focus();
          // window.open("/payment", "_blank",);
          navigate("/payment", {
            replace: true,
            state: {
              orderId,
              selectedPaymentMode,
              selected,
              selectedAddress,
              paymentUrl: data.checkout_url,
              type: selectedPaymentMode?.payment_method_name
            },
          });
          setPaymentLoader(false)
        } else
          if (data?.payment_id || data?.pck_key) {
            setPaymentid(data?.payment_id);
            setPaymentstatus(data?.payment_status);
            if (data?.pck_key) {
              setPaymentRelaykey(data?.pck_key);
            }
          } else {
            navigate(`/order-status?orderid=${data?.transaction_id}`, { state: { order: data } });
          }

        // ✅ Remove stored table number after successful order
        localStorage.removeItem("number");
        console.log("Table number removed from localStorage after successful order.");
      }

      setLoader(false);
    } catch (err) {
      console.log("Error:", err);
      setLoader(false);
    }
  };


  useEffect(() => {
    if (!addressList.length) {
      // setViewAddAddress(true)
      // setLoader(false)
    } else
      setViewAddAddress(false)
    getUserDetails()
  }, [addressList.length])
  useEffect(() => {
    getCartItems()
    getAddressList()
  }, [])
  useEffect(() => {
    getPaymentModes()
  }, [selected])

  // const addShippingAddress = async (formData, e) => {
  //   if (_.isEmpty(locationPin) || !locationPin.lat || !locationPin.lng) {
  //     enqueueSnackbar('Select your location in map', { variant: 'error' })
  //   }
  //   formData = {
  //     ...formData,
  //     latitude: locationPin.lat,
  //     longitude: locationPin.lng
  //   }
  //   if (formData.country_code && !formData.country_code.dial_code) {
  //     formData = {
  //       ...formData,
  //       country_code: GLOBAL_COUNTRY_CODE.dial_code,
  //     }
  //   } else if (formData.country_code) {
  //     formData = {
  //       ...formData,
  //       country_code: formData.country_code.dial_code,
  //     }
  //   }

  //   setLoader(true)
  //   let res = await axiosInstance.post(APIRouteConstants.DASHBOARD.ADD_ADDRESS_LIST, formData);
  //   let { data, response } = res;

  //   if (response
  //     && response.status == 400
  //     && response.data) {
  //     for (let i in response.data) {
  //       setLoader(false)
  //       enqueueSnackbar(_.capitalize(i) + ': ' + response.data[i][0], { variant: 'error' });
  //     }
  //   }

  //   if (data) {

  //     getAddressList();
  //     setViewAddAddress(false)
  //     reset()
  //   }
  // }

  const addShippingAddress = async (formData, e) => {
    if (_.isEmpty(locationPin) || !locationPin.lat || !locationPin.lng) {
      enqueueSnackbar('Select your location on the map', { variant: 'error' });
      return;
    }

    // Add latitude and longitude
    formData = {
      ...formData,
      latitude: locationPin.lat,
      longitude: locationPin.lng
    };

    // ✅ Get final country code:
    const finalDialCode = formData.country_code?.dial_code || formData.country_code || GLOBAL_COUNTRY_CODE?.dial_code || '';

    formData = {
      ...formData,
      country_code: finalDialCode,
    };

    setLoader(true);

    try {
      const res = await axiosInstance.post(APIRouteConstants.DASHBOARD.ADD_ADDRESS_LIST, formData);
      const { data, response } = res;

      if (response && response.status === 400 && response.data) {
        for (let i in response.data) {
          enqueueSnackbar(`${_.capitalize(i)}: ${response.data[i][0]}`, { variant: 'error' });
        }
        setLoader(false);
        return;
      }

      if (data) {
        getAddressList();
        setViewAddAddress(false);
        reset();
      }
    } catch (err) {
      console.error(err);
      enqueueSnackbar('Something went wrong while saving address', { variant: 'error' });
      setLoader(false);
    }
  };


  useEffect(() => {
    if (selected) {
      setLoader(true)
      getCartSummary(selectedAddress?.id)
    }
  }, [selectedAddress, selected])

  // useEffect(() => {
  //   const hasPickUpAtStore = websiteInfo?.delivery_option?.includes("store_pickup",)
  //   const hasRoomDeliver = websiteInfo?.delivery_option?.includes("room_deliver",)
  //   const hasShippingStore = websiteInfo?.delivery_option?.includes("shipping")
  //   const IS_mclardies_APP = "localhost:3000" === window?.location?.host || "mclardies.webbieshop.com" === window?.location?.host
  //   if (IS_mclardies_APP) {
  //     setSelected("store_pickup")
  //   } else if (!selected) setSelected(hasPickUpAtStore ? "store_pickup" : hasShippingStore ? "shipping" : hasRoomDeliver ? "room_deliver" : "")
  //   if (addressList.length > 0 && cartItems.length > 0 && paymentModes.length && !_.isEmpty(cartSummary))
  //     setLoader(false)
  // }, [addressList.length, cartItems.length, paymentModes.length, cartSummary])

  useEffect(() => {

    if (
      addressList.length > 0 &&
      cartItems.length > 0 &&
      paymentModes.length &&
      !_.isEmpty(cartSummary)
    ) {
      setLoader(false);
    }
  }, [

    selected,
    addressList.length,
    cartItems.length,
    paymentModes.length,
    cartSummary,
  ]);

  useEffect(() => {
    const hasStorePickup = Array.isArray(websiteInfo?.delivery_option) && websiteInfo?.delivery_option[0]
    // const hasRoomDelivery = websiteInfo?.delivery_option?.includes("room_deliver");
    // const hasShipping = websiteInfo?.delivery_option?.includes("shipping");

    const IS_MCLARDIES =
      window?.location?.host === "localhost:" ||
      window?.location?.host === "mclardies.webbieshop.com";

    if (IS_MCLARDIES) {
      setSelected("store_pickup");
    } else if (!selected) {
      // Default to available options in order of preference
      if (hasStorePickup) setSelected(hasStorePickup);
      // else if (hasShipping) setSelected("shipping");
      // else if (hasRoomDelivery) setSelected("room_deliver");
    }

    // Hide loader only when all essential data is present
  }, [
    websiteInfo?.delivery_option,
  ])


  const [isWebsiteFunctional, setIsWebsiteFunctional] = useState(false);
  const [hasCheckedWebsiteInfo, setHasCheckedWebsiteInfo] = useState(false); // 🔹 new flag


  const getWebsiteInfo = async () => {
    setLoader(true);
    try {
      const res = await axiosInstance.get(APIRouteConstants.DASHBOARD.WEB_INFO);
      const { data } = res;
      setIsWebsiteFunctional(data.status); // or data?.data?.status
    } catch (err) {
      console.error(err);
      setIsWebsiteFunctional(false);
    } finally {
      setLoader(false);
      setHasCheckedWebsiteInfo(true); // ✅ mark check as complete
    }
  };
  useEffect(() => {
    getWebsiteInfo();
  }, []);

  console.log('SELECTEDDDDD', selected)
  return (
    <CustomLayout>

      <Loaderwithtext open={paymentLoader} text={"Please wait, we are redirecting you to the payment page, thank you for your patience."} />
      <Loader open={loader} />
      <div className="content-container">
        <CustomBreadcrumbs list={breadcrumbs} name={"Checkout"} />
        <Divider className="divider" />
        <Grid container className="checkout-wrapper main-content-wrapper">
          <Grid container className="stepper-header">
            <div className="stepper-header-content">
              <span className="inactive" style={{ fontSize: '1.6rem' }}>SHOPPING CART</span>
              <ArrowForwardIcon style={{ marginBottom: '-3px', fontSize: '1.5rem' }} />
              <span className="active" style={{ fontSize: '1.6rem' }}>CHECKOUT</span>
              <ArrowForwardIcon style={{ marginBottom: '-3px', fontSize: '1.5rem' }} />
              <span className="inactive" style={{ fontSize: '1.6rem' }}>ORDER COMPLETE</span>
            </div>
          </Grid>


          <Grid container className="checkout-content" spacing={10}>

            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={6.5}
              mb={2}
              className="form-container"
            >
              {/* <Grid item
              xs={12}
              sm={12}
              md={12}
              lg={7}
              className="form-container"> */}
              <Card sx={{ p: { xs: 3, sm: 3, md: 3, lg: 5 } }} >
                <ShippingOptionCard onSelcted={handleSelect} selectAddress={selectAddress} setSelected={setSelected} selected={selected} paymentModess={paymentModes} websiteInfo={websiteInfo} />
                {/* </Grid> */}
                {selected === "store_pickup" &&
                  <Grid item xs={12} className="justify-title form-title" mt={5}>

                    <Typography sx={{ fontSize: customeStyle.typography.subhading, color: "#1976d2" }}>
                      Great choice! Your order will be ready for pickup at our store. Skip the wait and swing by whenever it's convenient for you. We can't wait to see you soon!
                    </Typography>
                  </Grid>

                }    {selected === "shipping" ? <>
                  {console.log("userdata", viewAddAddress)}
                  {(viewAddAddress && userData) ? (
                    <form onSubmit={handleSubmit(addShippingAddress)}>
                      <Grid container spacing={3} pt={3}>
                        <Grid item xs={12} className="form-title" pt={2}>
                          <Typography sx={{ fontSize: customeStyle.typography.subhading }} >SHIPPING DETAILS</Typography>
                        </Grid>
                        {!loader ? (
                          <GoogleMapContainer
                            setValue={setValue}
                            setLoader={setLoader}
                            location={locationPin}
                            selectLocation={selectLocation}
                          />
                        ) : (
                          ""
                        )}<Grid xs={12} sm={6} sx={{ pl: 2.5, pt: 1 }} >
                          <FormLabel sx={{ fontSize: customeStyle.typography.subhading1 }} >First Name</FormLabel>
                          <TextField
                            sx={{ p: 0 }}
                            margin="dense"
                            placeholder="Name"
                            type="text"
                            fullWidth

                            defaultValue={userData && userData?.first_name}
                            variant="outlined"
                            size="small"
                            {...register("first_name", { required: true })}
                            error={!!errors.first_name}
                            helperText={errors.first_name ? "First Name is required" : ""}
                            InputLabelProps={{ shrink: false }}
                            InputProps={{
                              sx: {
                                padding: 0, // Removes extra padding inside the input
                                '& .MuiInputBase-input': {
                                  padding: 0.5, // Removes internal padding
                                  height: "auto", // Ensures proper text alignment
                                  fontSize: "14px", // Sets input text font size
                                  '&::placeholder': {
                                    fontSize: "12px", // Sets placeholder font size
                                    opacity: 0.5, // Ensures visibility
                                  },
                                },
                              },
                            }}
                          />
                        </Grid>

                        <Grid Item xs={12} sm={6} sx={{ pl: 2.5, pt: 1 }} >
                          <FormLabel sx={{ fontSize: customeStyle.typography.subhading1 }}>Last Name</FormLabel>

                          <TextField
                            margin="dense"
                            placeholder="Enter Last Name"
                            type="text"
                            fullWidth
                            variant="outlined"
                            size="small"

                            defaultValue={userData && userData?.last_name}
                            {...register("last_name", { required: true })}
                            error={!!errors.last_name}
                            helperText={errors.last_name ? "Last Name is required" : ""}
                            InputLabelProps={{ shrink: false }}
                            InputProps={{
                              sx: {
                                padding: 0, // Removes extra padding inside the input
                                '& .MuiInputBase-input': {
                                  padding: 0.5, // Removes internal padding
                                  height: "auto", // Ensures proper text alignment
                                  fontSize: "14px", // Sets input text font size
                                  '&::placeholder': {
                                    fontSize: "12px", // Sets placeholder font size
                                    opacity: 0.5, // Ensures visibility
                                  },
                                },
                              },
                            }}
                          />
                        </Grid>

                        <Grid Item xs={12} sx={{ pl: 2.5, pt: 1 }} >
                          <FormLabel sx={{ fontSize: customeStyle.typography.subhading1 }}>House Number</FormLabel>
                          <TextField
                            margin="dense"
                            placeholder="House Number and Building Name"
                            type="text"
                            fullWidth
                            variant="outlined"
                            size="small"
                            {...register("house_number_or_building_number", { required: true })}
                            error={!!errors.house_number_or_building_number}
                            helperText={errors.house_number_or_building_number ? "House is required" : ""}
                            InputLabelProps={{ shrink: false }}
                            InputProps={{
                              sx: {
                                padding: 0, // Removes extra padding inside the input
                                '& .MuiInputBase-input': {
                                  padding: 0.5, // Removes internal padding
                                  height: "auto", // Ensures proper text alignment
                                  fontSize: "14px", // Sets input text font size
                                  '&::placeholder': {
                                    fontSize: "12px", // Sets placeholder font size
                                    opacity: 0.5, // Ensures visibility
                                  },
                                },
                              },
                            }}
                          />
                        </Grid>

                        <Grid Item xs={12} sx={{ pl: 2.5, pt: 1 }} >
                          <FormLabel sx={{ fontSize: customeStyle.typography.subhading1 }}>Street Address</FormLabel>
                          <TextField
                            margin="dense"
                            placeholder="Street Address"
                            type="text"
                            fullWidth
                            variant="outlined"
                            size="small"
                            {...register("street_address", { required: true })}
                            error={!!errors.street_address}
                            helperText={errors.street_address ? "Street Address is required" : ""}
                            InputLabelProps={{ shrink: false }}
                            InputProps={{
                              sx: {
                                padding: 0, // Removes extra padding inside the input
                                '& .MuiInputBase-input': {
                                  padding: 0.5, // Removes internal padding
                                  height: "auto", // Ensures proper text alignment
                                  fontSize: "14px", // Sets input text font size
                                  '&::placeholder': {
                                    fontSize: "12px", // Sets placeholder font size
                                    opacity: 0.5, // Ensures visibility
                                  },
                                },
                              },
                            }}
                          />
                        </Grid>

                        <Grid Item xs={12} sx={{ pl: 2.5, pt: 1 }}>
                          <FormLabel sx={{ fontSize: customeStyle.typography.subhading1 }}>Town / City</FormLabel>
                          <TextField
                            margin="dense"
                            placeholder="Enter Town / City"
                            type="text"
                            fullWidth
                            variant="outlined"
                            size="small"
                            {...register("city", { required: true })}
                            error={!!errors.city}
                            helperText={errors.city ? "City is required" : ""}
                            InputLabelProps={{ shrink: false }} InputProps={{
                              sx: {
                                padding: 0, // Removes extra padding inside the input
                                '& .MuiInputBase-input': {
                                  padding: 0.5, // Removes internal padding
                                  height: "auto", // Ensures proper text alignment
                                  fontSize: "14px", // Sets input text font size
                                  '&::placeholder': {
                                    fontSize: "12px", // Sets placeholder font size
                                    opacity: 0.5, // Ensures visibility
                                  },
                                },
                              },
                            }}
                          />
                        </Grid>

                        <Grid Item xs={12} sm={6} sx={{ pl: 2.5, pt: 1 }}>
                          <FormLabel sx={{ fontSize: customeStyle.typography.subhading1 }}>State</FormLabel>
                          <TextField
                            margin="dense"
                            placeholder="Enter State"
                            type="text"
                            fullWidth
                            variant="outlined"
                            size="small"
                            disabled
                            {...register("state", { required: true })}
                            error={!!errors.state}
                            helperText={errors.state ? "State is required" : ""}
                            InputLabelProps={{ shrink: false }} InputProps={{
                              sx: {
                                padding: 0, // Removes extra padding inside the input
                                '& .MuiInputBase-input': {
                                  padding: 0.5, // Removes internal padding
                                  height: "auto", // Ensures proper text alignment
                                  fontSize: "14px", // Sets input text font size
                                  '&::placeholder': {
                                    fontSize: "12px", // Sets placeholder font size
                                    opacity: 0.5, // Ensures visibility
                                  },
                                },
                              },
                            }}
                          />
                        </Grid>

                        <Grid Item xs={12} sm={6} sx={{ pl: 2.5, pt: 1 }}>
                          <FormLabel sx={{ fontSize: customeStyle.typography.subhading1 }}>Country</FormLabel>
                          <TextField
                            margin="dense"
                            placeholder="Enter Country"
                            type="text"
                            fullWidth
                            variant="outlined"
                            size="small"
                            disabled
                            {...register("country", { required: true })}
                            error={!!errors.country}
                            helperText={errors.country ? "Country is required" : ""}
                            InputLabelProps={{ shrink: false }} InputProps={{
                              sx: {
                                padding: 0, // Removes extra padding inside the input
                                '& .MuiInputBase-input': {
                                  padding: 0.5, // Removes internal padding
                                  height: "auto", // Ensures proper text alignment
                                  fontSize: "14px", // Sets input text font size
                                  '&::placeholder': {
                                    fontSize: "12px", // Sets placeholder font size
                                    opacity: 0.5, // Ensures visibility
                                  },
                                },
                              },
                            }}
                          />
                        </Grid>

                        <Grid Item xs={12} sm={6} sx={{ pl: 2.5, pt: 1 }}>
                          <FormLabel sx={{ fontSize: customeStyle.typography.subhading1 }}>PIN</FormLabel>
                          <TextField
                            margin="dense"
                            placeholder="PIN"
                            type="text"
                            fullWidth
                            variant="outlined"
                            size="small"
                            {...register("pin", { required: true })}
                            error={!!errors.pin}
                            helperText={errors.pin ? "Pincode is required" : ""}
                            InputLabelProps={{ shrink: false }}

                            InputProps={{
                              sx: {
                                padding: 0, // Removes extra padding inside the input
                                '& .MuiInputBase-input': {
                                  padding: 0.5, // Removes internal padding
                                  height: "auto", // Ensures proper text alignment
                                  fontSize: "14px", // Sets input text font size
                                  '&::placeholder': {
                                    fontSize: "12px", // Sets placeholder font size
                                    opacity: 0.5, // Ensures visibility
                                  },
                                },
                              },
                            }}
                          />
                        </Grid>

                        <Grid container spacing={2} alignItems="center" justifyContent="space-between" pl={2} mt={0.5}>
                          <Grid item xs={12}>
                            <Controller
                              name="phone_number"
                              control={control}
                              defaultValue={userData?.mobile_number || ""}
                              rules={{
                                required: "Mobile number is mandatory",
                                minLength: {
                                  value: 9,
                                  message: "Mobile number must be between 9–15 digits",
                                },
                                maxLength: {
                                  value: 15,
                                  message: "Mobile number must be between 9–15 digits",
                                },
                              }}
                              render={({ field: { value, onChange } }) => (
                                <MuiResponsivePhoneInputControlled
                                  userData={userData}
                                  value={value}
                                  defaultCountry="za"
                                  setMobile={(val) => {
                                    onChange(val.number); // updates form value
                                    setValue("phone_number", val.number); // ensures validation
                                    setValue("country_code", val.dialCode); // saves country code separately
                                  }}
                                />
                              )}
                            />

                          </Grid>

                          {!!errors.phone_number && (
                            <Grid item xs={12} mt={1} textAlign="center">
                              <Typography color="error" fontSize="0.7rem">
                                {errors.phone_number.message}
                              </Typography>
                            </Grid>
                          )}
                        </Grid>



                        <Grid item xs={12} sx={{ display: "flex", gap: 2, mt: 2 }}>
                          <Button sx={{ fontSize: customeStyle.typography.subhading1 }} type="submit" color="secondary" variant="contained" size="small">
                            Add Address
                          </Button>
                          <Button
                            color="error"
                            variant="outlined"
                            size="small"
                            // disabled={!addressList.length}
                            onClick={() => setViewAddAddress(false)}
                            sx={{ fontSize: customeStyle.typography.subhading1 }}
                          >
                            Cancel
                          </Button>
                        </Grid>

                      </Grid>
                    </form>
                  ) : (
                    <Grid container spacing={3} pt={2}>
                      <Grid item xs={12} alignItems={"center"} className="justify-title form-title">
                        <Typography sx={{ fontSize: customeStyle.typography.subhading }}>
                          Select from Existing Addresses:
                        </Typography>
                        <Button
                          variant="outlined"
                          size='small'
                          onClick={() => {
                            setViewAddAddress(true);
                            selectLocation();
                            reset();
                          }}
                          startIcon={<AddIcon />}
                          sx={{ fontSize: customeStyle.typography.subhading1, textTransform: "none" }}
                        >
                          Add new address
                        </Button>
                      </Grid>
                      <Grid item sm={12} className="form-wrapper" >

                        <FormControl fullWidth>
                          <RadioGroup

                            aria-labelledby="demo-radio-buttons-group-label"
                            defaultValue="female"
                            name="radio-buttons-group"
                          >
                            <List sx={{ pl: 0, }}>

                              {addressList.map((address) => (
                                <ListItem key={address.id} sx={{ pl: 0, display: "flex", alignItems: "flex-start", }} >
                                  <Radio
                                    sx={{ pt: 0, m: 0 }}
                                    size={"0.8rem"}
                                    onClick={() => selectAddress(address)}
                                    checked={
                                      selectedAddress
                                        ? selectedAddress.id == address.id
                                        : false
                                    }
                                  />
                                  {showAddress(address)}

                                </ListItem>
                              ))}
                            </List>
                            {/* <FormControlLabel value="male" control={<Radio />} label="Credit / Debit Card" /> */}
                          </RadioGroup>
                        </FormControl>

                      </Grid>
                    </Grid>
                  )}
                </> : null}
                {selected === "room_deliver" &&
                  <Grid item xs={12} className="justify-title form-title" mt={5}>

                    <Typography sx={{ fontSize: customeStyle.typography.subhading, color: "#1976d2" }}>
                      Excellent choice! Your order will be delivered straight to your room. Just sit back and relax while we bring everything right to your doorstep. Comfort and convenience, just the way you like it!
                    </Typography>
                  </Grid>

                }
              </Card>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={5.5} >
              <Grid p={2} borderRadius={1} boxShadow={2} bgcolor="#f7f7f7">
                <Typography sx={{ fontSize: customeStyle.typography.subhading }} fontWeight="bold" gutterBottom>
                  YOUR ORDER
                </Typography>
                <Divider sx={{ mb: 2 }} />

                {cartItems.map((item, i) => (
                  <Grid container key={i} alignItems="center" justifyContent="space-between" mb={2}>
                    <Grid container alignItems="center" xs={8}>
                      <Grid item>
                        
                        <CardMedia
                          component={"img"}
                          src={item.product_image||item?.image_url}
                          alt={item.product_name}
                          sx={{ width: "4rem", height: "100%", borderRadius: 2, objectFit: "fill", marginRight: 2 }}
                        />
                      </Grid>
                      <Grid item>
                        <Typography sx={{ fontSize: customeStyle.typography.subhading }} fontWeight="500">
                          {item.product_name||item?.name}
                        </Typography>
                        {(((item?.size &&
                          item?.size !== '' &&
                          item?.size !== 'null'))) && <Typography sx={{ fontSize: customeStyle.typography.subhading }} color="text.secondary">
                            Size: {item.size || item?.size?.name}
                          </Typography>}
                        {(((item?.color &&
                          item?.color !== '' &&
                          item?.color !== 'null'))) && <Typography sx={{ fontSize: customeStyle.typography.subhading }} color="text.secondary">
                            Color: {item.color || item?.color?.name}
                          </Typography>}
                        <Typography sx={{ fontSize: customeStyle.typography.subhading }} color="text.secondary">
                          Qty: {item.quantity}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid item>
                      <Typography sx={{ fontSize: customeStyle.typography.subhading }} fontWeight="500">
                        {formatCurrencyNew(item.product_price, websiteInfo?.currency_symbol)}
                      </Typography>
                    </Grid>
                  </Grid>
                ))}

                <Divider sx={{ my: 2 }} />

                {/* Sub Total */}
                <Grid container justifyContent="space-between" mb={1}>
                  <Typography sx={{ fontSize: customeStyle.typography.subhading }} color="text.secondary">Sub Total</Typography>
                  <Typography sx={{ fontSize: customeStyle.typography.subhading }} fontWeight="bold">{formatCurrencyNew(cartSummary?.cart_total || 0, websiteInfo?.currency_symbol)}</Typography>
                </Grid>

                {/* Coupon Discount */}
                {cartSummary?.coupon_discount > 0 && (
                  <>
                    <Grid container justifyContent="space-between" mb={1}>
                      <Typography sx={{ fontSize: customeStyle.typography.subhading }} color="text.secondary">Coupon Discount</Typography>
                      <Typography sx={{ fontSize: customeStyle.typography.subhading }} fontWeight="bold">-{formatCurrencyNew(cartSummary?.coupon_discount || 0, websiteInfo?.currency_symbol)}</Typography>
                    </Grid>
                    <Grid container justifyContent="space-between" mb={1}>
                      <Typography sx={{ fontSize: customeStyle.typography.subhading }} color="text.secondary">Price After Discount</Typography>
                      <Typography sx={{ fontSize: customeStyle.typography.subhading }} fontWeight="bold">{formatCurrencyNew(cartSummary?.price_after_coupon || 0, websiteInfo?.currency_symbol)}</Typography>
                    </Grid>
                  </>
                )}

                {/* Shipping */}
                {selectedAddress || selected === "store_pickup" ? (
                  cartSummary?.Shipping > 0 && (
                    <>
                      <Divider sx={{ my: 2 }} />
                      <Grid container justifyContent="space-between" mb={1}>
                        <Typography sx={{ fontSize: customeStyle.typography.subhading }} color="text.secondary">Shipping</Typography>
                        <Typography sx={{ fontSize: customeStyle.typography.subhading }} fontWeight="bold">{formatCurrencyNew(cartSummary?.Shipping || 0, websiteInfo?.currency_symbol)}</Typography>
                      </Grid>
                    </>
                  )
                ) : null}

                <Divider sx={{ my: 2 }} />

                {/* Total */}
                <Grid container justifyContent="space-between" mb={2}>
                  <Typography sx={{ fontSize: customeStyle.typography.subhading }} fontWeight="bold">Total</Typography>
                  <Typography sx={{ fontSize: customeStyle.typography.subhading }} fontWeight="bold">{formatCurrencyNew(cartSummary?.sub_total || 0, websiteInfo?.currency_symbol)}</Typography>
                </Grid>

                {/* Payment Modes */}
                {selectedAddress || selected === "store_pickup" || selected === "room_deliver" ? (
                  <>
                    <Divider sx={{ my: 2 }} />
                    <PaymentModeSelector
                      message={message}
                      paymentModes={paymentModes}
                      selectedPaymentMode={selectedPaymentMode}
                      selectPaymentMode={selectPaymentMode}
                    />
                    <Divider sx={{ my: 2 }} />

                    {/* Payment Button */}
                    {/* <Grid container justifyContent="center">
                      <Button variant="contained" size='small' fullWidth onClick={proceedOrder} sx={{ py: 1, fontSize: customeStyle.buttomfont, borderRadius: 2 }}>
                        Pay now
                      </Button>
                    </Grid> */}
                    <Grid container justifyContent="center">
                      <Button
                        variant="contained"
                        size="small"
                        fullWidth
                        onClick={proceedOrder}
                        disabled={hasCheckedWebsiteInfo && !isWebsiteFunctional}
                        sx={{
                          py: 1,
                          fontSize: customeStyle.buttomfont,
                          borderRadius: 2,
                        }}
                      >
                        Pay now
                      </Button>
                    </Grid>

                    {/* 🔴 Store Offline Notice */}
                    {hasCheckedWebsiteInfo && !isWebsiteFunctional && (
                      <div
                        style={{
                          marginTop: "12px",
                          backgroundColor: "#FFEBEE",
                          padding: "10px 12px",
                          borderRadius: "6px",
                          border: "1px solid #C62828",
                          color: "#C62828",
                          fontWeight: 600,
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          fontSize: "0.95rem",
                        }}
                      >
                        <span>⚠️</span>
                        The store is currently offline. Please try again later.
                      </div>
                    )}

                  </>
                ) : null}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
      {paymentstatus == "pending" &&
        <PayButton paymentId={paymentid} storeorderid={orderId} orderId={orderId} setPaymentstatus={setPaymentstatus} relayKey={paymentidRelaykey} setLoader={setLoader} />}
    </CustomLayout>
  );
}

export default Checkout



export function PayButton({ paymentId, order_Id, storeorderid, setLoader, relayKey, setPaymentstatus }) {
  const buttonRef = useRef(null);
  const [isSDKReady, setSDKReady] = useState(false);
  const [SticittPaySDK, setsticittPaySDK] = useState();
  const [SticittPay, setsticittPay] = useState(true);
  const navigate = useNavigate();

  const { enqueueSnackbar } = useSnackbar();

  const loadSticittPaySDK = (useTestSDK, setSDKReady, setSticittPaySDK) => {

    // Match the existing script IDs in index.html
    const scriptId = "sticitt-pay-sdk"; // This is the same for both SDKs
    const oldScript = document.getElementById(scriptId);
    if (oldScript) oldScript.remove();

    // Create and append the script dynamically
    const sdkScript = document.createElement("script");
    sdkScript.id = scriptId;
    sdkScript.src = useTestSDK
      // ? "https://sdk-test.sticitt.co.za/js/lib/sdk-relay.min.js"
      ? "https://sdk.sticitt.co.za/js/lib/sdk-relay.min.js"
      : "https://sdk.sticitt.co.za/js/lib/sdk.min.js";

    if (useTestSDK) {
      console.log("sdk test",useTestSDK)
      sdkScript.setAttribute("data-client-id", "webbieshop-app");
      sdkScript.setAttribute(
        "data-client-secret",
        "GAWtzPuPKK@JHAC7!Lyb4aFeyRF87qq!9VfFj!mD@nEDMP8VM!ekqtjFd@-Qnf2V"
      );
    }

    sdkScript.onload = () => {
      setSDKReady(true);
      setSticittPaySDK(window.SticittPaySDK);
    };

    sdkScript.onerror = () => {
      console.error("Failed to load Sticitt SDK");
    };

    document.body.appendChild(sdkScript);
  };

  const handleClose = () => {
    setsticittPay(!SticittPay);
    setPaymentstatus(null)
  }

  const handleModalClose = () => {
    setsticittPay(!SticittPay);
    setPaymentstatus(null)
    handlecancelpay();
  }

  const handlecancelpay = useCallback(async () => {
    try {
      // handleClose();
      setLoader(true)
      let res = await instance.post("/sticitt_pay/cancel-sticitt-payment/", {
        transaction_id: order_Id ? order_Id : storeorderid,
      });
      let { data } = res;
      if (data && data?.message === "Payment Cancelled successfully.") {
       
    navigate("/cart")
      }
    } catch (error) {
      setLoader(false)
      console.error("Error fetching payment status:", error);
    }
    return () => {
      setSDKReady(false)
    }
  }, [order_Id, storeorderid, navigate]);

  useEffect(() => {

    if (paymentId && relayKey == null) {

      loadSticittPaySDK(false, setSDKReady, setsticittPaySDK);
    } else if (paymentId && relayKey != null) {

      loadSticittPaySDK(true, setSDKReady, setsticittPaySDK);
    }
  }, [paymentId, relayKey]);



  const handleRedirect = useCallback(async () => {
    try {
      handleClose();

      navigate(`/order-status?orderid=${order_Id ? order_Id : storeorderid}`)
    } catch (error) {
      setLoader(false)
      console.error("Error fetching payment status:", error);
    }
  }, [order_Id, storeorderid, navigate]);

  useEffect(() => {
    if (!isSDKReady || !SticittPaySDK || !buttonRef.current) {
      console.warn("SDK not ready or buttonRef missing.");
      return;
    }


    try {
      // Ensure SDK is initialized before adding buttons
      if (typeof SticittPaySDK.Init === "function") {
        SticittPaySDK.Init();
      } else {
        console.warn("SticittPaySDK.Init() is not a function.");
      }

      // Check if PayButton constructor exists
      if (typeof SticittPaySDK.PayButton !== "function") {
        console.error("SticittPaySDK.PayButton is not a function.");
        return;
      }


      // Create PayButton instance
      const payButtonInstance = new SticittPaySDK.PayButton(buttonRef.current, {
        onPaid: (button, paymentId) => {
          setTimeout(handleRedirect, 3000);
        },
        onClosed: (button, paymentId) => {
          setTimeout( handleModalClose,3000)
          handlecancelpay();
        },
      });


      // Check if AddButton exists and add the button
      if (typeof SticittPaySDK.AddButton === "function") {
        SticittPaySDK.AddButton(payButtonInstance);
      } else {
        console.error("SticittPaySDK.AddButton is not a function.");
      }
    } catch (error) {
      console.error("Error initializing PayButton:", error);
    }
  }, [isSDKReady, SticittPaySDK, handleRedirect]);


  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 390,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
  };
  return (
    <Modal open={SticittPay}>
      <Box sx={style}>
        {/* Close Button with Icon */}
        <IconButton
          aria-label="close"
          onClick={handleModalClose}
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>


        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
          <img src={require('assets/icons/sticittpaylogo.png')} alt="Logo" width="200" />
        </Box>

        {/* Modal Content */}
        <Typography variant="h6" component="h2" align="center">
          Payment Information
        </Typography>
        <Typography sx={{ mt: 2, mb: 4 }} align="center">
          Complete your payment by clicking the button below.
        </Typography>

        {/* Pay Button */}
        {(paymentId && relayKey == null) ? <Button
          ref={buttonRef}
          variant="contained"
          color="primary"
          data-payment-id={paymentId}
          fullWidth
        >
          Pay with sticitt
        </Button>
          : <Button
            ref={buttonRef}
            variant="contained"
            color="primary"
            data-payment-id={paymentId}
            data-relay-key={relayKey}

            fullWidth
          >
            Pay with sticitt
          </Button>}
      </Box>
    </Modal>
  );
}

function PaymentModeSelector({ message, paymentModes, selectPaymentMode, selectedPaymentMode }) {
  const selectPaymentModeChange = (mode) => {
    selectPaymentMode(mode);
  };

  const modifiedPaymentModes = useMemo(() => {
    return paymentModes.flatMap((payment) => {
      if (payment.payment_method_name === "Peach Payments") {
        return [
          { ...payment, type: "debit", blockname: "Credit/Debit card" },
          { ...payment, type: "eft", blockname: "Instant EFT" },
        ];
      }

      return {
        ...payment,
        type: payment.payment_method_name,
        blockname:
          payment.payment_method_name === "Cash on delivery(COD)"
            ? "Cash on delivery (COD)"
            : payment.payment_method_name,
      };
    });
  }, [paymentModes]);

  useEffect(() => {
    if (modifiedPaymentModes.length === 1) {
      selectPaymentMode(modifiedPaymentModes[0]);
    }
  }, [modifiedPaymentModes]);

console.log("selectedPaymentMode",selectedPaymentMode)
  const getPaymentLogo = (type) => {
    switch (type) {
      case "debit":
        return Payblocktwo;
      case "eft":
        return EFT;
      case "Cash on delivery(COD)":
        return COD;
      case "Sticitt Pay":
        return Payblockfour;
      case "Pay at Store":
        return Patstore;
      case "Pay at Reception":
        return Payatreception;
        case "Zapper":
        return Zapper;
        case "Ikhokha Payments":
        return Ikhokha;
       
      default:
        return "https://example.com/default-logo.png"; // Default logo
    }
  };

  return (
    <>
      <Typography sx={{ pb: 2, fontSize: customeStyle.typography.subhading1 }} >Please select a payment method to proceed.</Typography>
      {message && <Typography sx={{ color: "red", pb: 1, fontSize: customeStyle.typography.subhading1 }} >{message}</Typography>}
      <Grid container spacing={0.5}>
        {modifiedPaymentModes.map((mode) => (
          <Grid item xs={2.4} sm={2.4} md={2.4} lg={2.4} key={mode.id} textAlign={"center"}>
            <Card
              sx={{
                border: selectedPaymentMode && selectedPaymentMode.type === mode.type ? "2px solid #1976d2" : "1px solid #ccc",
                background: selectedPaymentMode && selectedPaymentMode.type === mode.type ? "#f7f7f7" : "#fff",
                cursor: "pointer",
                height: { xs: "6rem", sm: "5rem", md: "5rem", lg: "6rem" }, // Fixed height for the card
                borderRadius: "0.7rem",
                alignSelf: "center",
                overflow: "visible",
                transition: "border 0.3s ease, box-shadow 0.3s ease", // Smooth transition for border and shadow
                boxShadow: selectedPaymentMode && selectedPaymentMode.type === mode.type ? "0px 4px 8px rgba(0, 0, 0, 0.2)" : "none", // Highlight the selected card with a shadow
                position: "relative", // Needed for positioning the check icon

              }}
              onClick={() => selectPaymentModeChange(mode)}
            >
              {selectedPaymentMode && selectedPaymentMode.type === mode.type && (
                <CheckCircleIcon
                  sx={{
                    position: "absolute",
                    top: -5,
                    right: -5,
                    color: "#1976d2",
                    fontSize: 20, // Adjust size as needed
                    backgroundColor: "#fff",
                    borderRadius: "50%",
                    zIndex: 99
                  }}
                />
              )}
              <CardContent
                sx={{
                  textAlign: "center",
                  p: 0.6,
                  alignItems: "center",
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column"
                }}
              >
                <CardMedia component={"img"} src={getPaymentLogo(mode?.type)} sx={{ filter: "grayscale(0%) brightness(70%) contrast(200%)", objectFit: "contain", width: "100%", height: mode.type === "debit" ? "3rem" : "3rem" }} />
                {/* {mode.type==="debit" &&  <CardMedia component={"img"} src={VISA} sx={{filter: "grayscale(100%) brightness(50%) contrast(120%)",  objectFit: "contain", width: "100%", height: "1.5rem" }} />} */}
                <FormControlLabel
                  value={mode.id}
                  control={
                    <Radio
                      checked={selectedPaymentMode && selectedPaymentMode.type === mode.type}
                      onClick={(e) => e.stopPropagation()} // Prevent radio click from triggering card click
                      sx={{ display: "none" }} // Hide the radio button
                    />
                  }
                  sx={{ display: "none" }} // Hide the radio button
                />
                <Typography sx={{ fontSize: "0.55rem" }}>{mode.blockname}</Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </>
  );
}

